// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const qwilfish_hisui: PokeData = {
  "id": 10234,
  "name": "qwilfish-hisui",
  "height": 5,
  "weight": 39,
  "base_experience": 88,
  "types": [
    PokeType.DARK,
    PokeType.POISON
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "poison-sting",
    "pin-missile",
    "bite",
    "toxic",
    "harden",
    "minimize",
    "self-destruct",
    "spikes",
    "destiny-bond",
    "crunch",
    "stockpile",
    "spit-up",
    "water-pulse",
    "brine",
    "acupressure",
    "toxic-spikes",
    "poison-jab",
    "dark-pulse",
    "aqua-tail",
    "fell-stinger",
    "barb-barrage"
  ],
  "moves": [
    "tackle",
    "pin-missile",
    "bite",
    "crunch",
    "brine",
    "toxic-spikes",
    "poison-jab",
    "dark-pulse",
    "aqua-tail",
    "poison-fang",
    "phantom-force",
    "poison-powder",
    "mortal-gas"
  ],
  "evolution_chain": {
    "id": 106,
    "item": null,
    "species": [
      {
        "name": "qwilfish",
        "order": 242,
        "types": [
          PokeType.WATER,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "overqwil",
        "order": 904,
        "types": [
          PokeType.DARK,
          PokeType.POISON
        ],
        "evolves_from_species_id": 211,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "barb-barrage"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.STRONG_STYLE_MOVE
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 109,
    "speed": 137,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
